export const USER_CHANGE = "USER_CHANGE";
export const TAB_CHANGE = "TAB_CHANGE";
export const SET_USER = "SET_USER";

const userChangeAction = payload => ({
    type: USER_CHANGE,
    modelPayload: payload
});
const tabChangeAction = payload => ({
    type: TAB_CHANGE,
    tabPayload: payload
});
const onSelectUserViewAction = payload => ({
    type: SET_USER,
    user: payload
});

export { userChangeAction, tabChangeAction, onSelectUserViewAction };